<div class="editable-row" *transloco="let t">
  <p class="title">
    @if (roleHolderTitleSingularTranslationKey || roleHolderTitlePluralTranslationKey) {
      <span>
        {{
        roleHolders.length === 1
        ? t(roleHolderTitleSingularTranslationKey)
        : t(roleHolderTitlePluralTranslationKey)
        }}
      </span>
    }

    @if (roleHolders.length) {
      <button class="btn btn-sm btn-primary primary-dark" (click)="toggleRoleLock()"
        >
        @if (!locked) {
          <span>
            <i class="fa-solid fa-lock-open mr-2"></i>{{t('common.lock')}}
          </span>
        }
        @if (locked) {
          <span>
            <i class="fa-solid fa-lock mr-2"></i>{{t('common.unlock')}}
          </span>
        }
      </button>
    }
  </p>
  @if (roleHolderSubtitleTranslationKey) {
    <p>{{ t(roleHolderSubtitleTranslationKey) }}</p>
  }
  @if (roleHolders.length) {
    <div class="mt-3">
      <div class="contributors">
        @for (roleHolder of roleHolders; track roleHolder) {
          <span>
            <multisite-avatar-pill (selected)="removeRoleHolder(roleHolder.email)" [cursorNone]="locked"
                  [removalMode]="allowRoleHolderRemovalMode" [fallbackImageUrl]="
                'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'
              " [fallbackTranslationKey]="'social.verified_user'" [imageUrl]="roleHolder | userAvatar" [text]="
                (roleHolder.pre_honorific ? (roleHolder.pre_honorific+' ') : '') +
                roleHolder.fname +
                ' ' +
                roleHolder.lname +
                (roleHolder.post_honorific ? ' '+roleHolder.post_honorific : '')
              "></multisite-avatar-pill>
          </span>
        }
      </div>
    </div>
  }
  <button (click)="showNewRoleHolderForm = !showNewRoleHolderForm" class="btn btn-primary" [disabled]="loading">
    <div class="icon-left">
      <i class="fa-solid fa-plus"></i>
    </div>
    {{
    showNewRoleHolderForm
    ? t('common.cancel')
    : t('common.new')
    }}
  </button>

  @if (showNewRoleHolderForm) {
<multisite-email-input-form [labelTextTranslationKey]="
        'common.enter_person_email_address'
      " (emailSubmitted)="addRoleHolder({name:'a fake name', email: $event})" [errorTranslationKey]="error"
      [loading]="loading" ngClass="w-100">
    </multisite-email-input-form>
  }
  @if (error) {
    <alert [type]="'warning'" [dismissible]="true">
      <span *transloco="let t">{{ t(error) }}</span>
    </alert>
  }
</div>